// extracted by mini-css-extract-plugin
export default {"container":"explore_container__tB+tY","main":"explore_main__ITrBF","imgCont":"explore_imgCont__SEZyX","paraCont":"explore_paraCont__m0LiP","fadeInUp":"explore_fadeInUp__ESZtE"};